export default __webpack_public_path__ + "static/media/A Kiss.0dcfbf2a.png";